import styled from 'styled-components'
import { COLOURS } from 'resources'

export const RewardItemCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  margin: 10px 20px;
  background-color: ${COLOURS.neutralGrey1};
  border-radius: 6px;
  cursor: pointer;
`

export const RewardItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const RewardItemInfoRow = styled.div`
  display: flex;
  align-items: center;
`

export const RewardItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const RewardItemImage = styled.img`
  width: 70px;
  height: 70px;
  margin-right: 10px;
`

export const RewardItemNameRow = styled.div`
  display: flex;
  align-items: flex-start;
`

export const RewardItemName = styled.p`
  flex: 1;
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
`

export const RewardItemDescription = styled.p`
  font-size: 18px;
  line-height: 24px;
  text-transform: lowercase;
`

export const RewardArrow = styled.i`
  font-size: 24px;
  color: ${COLOURS.neutralBlack};
`

export const DisabledRewardContainer = styled.div`
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  filter: ${({ isDisabled }) => (isDisabled ? 'grayscale(100%)' : 'none')};
`
